import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/assets/css/base.css';
import '../src/assets/css/layout.css';
import App from './App';
import { CookiesProvider } from "react-cookie";
import reducer, { initialState } from "./store/reducer";
import { StateProvider } from "./store/StateProvider";

const root = createRoot(document.getElementById('root'));
root.render(
    <StateProvider initialState={initialState} reducer={reducer}>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </StateProvider>
);
